import { cloneDeep } from 'lodash';

export default {
	audit: state => cloneDeep(state.oneAudit),
	audits: state => cloneDeep(state.audits),
	loading: state => cloneDeep(state.loading),
	personWithAudit: state => cloneDeep(state.personWithAudit),
};
